<template>
    <MainContent title='Detalle de la pregunta frecuente'>
        <template v-slot:header>
            <h3 class="card-title mx-auto" v-if="!loading">{{ faq.title }}</h3>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <div v-html="faq.description" v-if="!loading">
                </div>
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';

    export default {
        props: ['faq_id'],
        components: {
            MainContent,
            ContentOrLoading,
        },
        data() {
            return {
                faq: null,
                loading: true,
            }
        },
        created() {
            this.getFaq();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            getFaq: function() {
                this.loading = true;
                const params = {
                    filters: {},
                    faq_id: this.faq_id,
                }
                this.$store
                    .dispatch(this.config.getVuexAlias('back.faqs.show'), params)
                    .then(res => {
                        this.faq = res.data.data;
                    })
                    .finally(() => this.loading = false);
            },
        },
    }
</script>
